import { define } from '../../define.js';
import { LuxenStories } from './stories.js';
export * from './stories.js';
define('stories', LuxenStories);
